import { baseQuery } from "./base-query";
import { createApi } from "@reduxjs/toolkit/query/react";

interface SystemSettings {
  ieepaRefundAlert: boolean;
}

export const systemSettingsApi = createApi({
  reducerPath: "systemSettingsApi",
  baseQuery,
  tagTypes: ["SystemSettings"],
  endpoints: (builder) => ({
    getSystemSettings: builder.query<SystemSettings, void>({
      query: () => ({
        document: `
          query GetSystemSettings {
            getSystemSettings { ieepaRefundAlert }
          }
        `,
      }),
      transformResponse: (response: { getSystemSettings: SystemSettings }) =>
        response.getSystemSettings,
      providesTags: ["SystemSettings"],
    }),
    setIeepaRefundAlert: builder.mutation<SystemSettings, { enabled: boolean }>({
      query: (variables) => ({
        document: `
          mutation SetIeepaRefundAlert($enabled: Boolean!) {
            setIeepaRefundAlert(enabled: $enabled) { ieepaRefundAlert }
          }
        `,
        variables,
      }),
      transformResponse: (response: { setIeepaRefundAlert: SystemSettings }) =>
        response.setIeepaRefundAlert,
      invalidatesTags: ["SystemSettings"],
    }),
  }),
});

export const {
  useGetSystemSettingsQuery,
  useSetIeepaRefundAlertMutation,
} = systemSettingsApi;
